<template>
  <div class="block">
    <!-- table actions -->
    <div class="px-5 py-5">
      <!-- top search bar -->
      <div class="d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon" style="top: 45%;">
            <v-icon>search</v-icon>
          </div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getContacts">搜尋</button>
      </div>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div class="form-item d-flex px-5 h-60px align-center">
          <h5 class="col-icon"></h5>
          <h5 class="col-area w-150px">Area</h5>
          <h5 class="col-location w-150px">Location</h5>
          <h5 class="col-address">Address</h5>
          <h5 class="col-icon ml-auto">編輯</h5>
          <h5 class="col-icon">刪除</h5>
        </div>
      </div>
      <div class="table-body">
        <TableCollapse v-for="item in contacts" :key="item.id">
          <!-- row 1 -->
          <template v-slot:head="slotProps">
            <div class="form-item d-flex h-60px align-center">
              <div class="h5 col-icon">
                <v-icon color="ink-01-emphasis" v-if="!slotProps.isBodyShow"
                  >unfold_more</v-icon
                >
                <v-icon color="ink-01-emphasis" v-if="slotProps.isBodyShow"
                  >unfold_less</v-icon
                >
              </div>
              <div class="h5 col-area w-150px">{{ item.area }}</div>
              <div class="h5 col-location w-150px">{{ item.location }}</div>
              <div class="h5 col-address">{{ item.address }}</div>
              <div class="h5 col-icon ml-auto">
                <button class="btn square" @click.stop="editItem(item.id)">
                  <v-icon>edit</v-icon>
                </button>
              </div>
              <h5 class="col-icon">
                <deleteDialog
                  @confirm-delete="deleteItem(item.id)"
                ></deleteDialog>
              </h5>
            </div>
          </template>
          <!-- row 2 -->
          <template v-slot:body>
            <div class="form-item py-5" style="font-size: 14px;">
              <!-- Area -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">Area</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.area }}</div>
              </div>
              <!-- Location -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">Location</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.location }}</div>
              </div>
              <!-- Address -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">Address</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.address }}</div>
              </div>
              <!-- Tel. -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">Tel.</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.tel }}</div>
              </div>
              <!-- Email -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">Email</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.email }}</div>
              </div>
              <!-- Url. -->
              <div class="d-flex pa-10px highlight-at-oddline">
                <h5 class="w-120px mr-10px">URL.</h5>
                <div class="flex-grow-1 flex-basis-0">{{ item.url }}</div>
              </div>
              <!-- Image. -->
              <div class="d-flex pa-10px">
                <h5 class="w-120px mr-10px">Image.</h5>
                <div class="flex-grow-1 flex-basis-0">
                  <div
                    v-if="item.image"
                    class="bg-cover bg-center"
                    :style="{
                        width: '512px',
                        height: '298px',
                        'background-image': `url(${item.image})`,
                      }"
                  ></div>
                </div>
              </div>
            </div>
          </template>
        </TableCollapse>
      </div>
    </div>

    <!-- table footer -->
    <Pagination @handleNextPreEvent="getContacts" model="contact"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableCollapse from '@/components/TableCollapse.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    TableCollapse,
    deleteDialog,
    Pagination,
  },
  data: () => ({}),
  computed: {
    ...mapState('contact', ['contacts', 'filter', 'areaOptions']),
  },
  methods: {
    ...mapActions('contact', {
      getContacts: 'find',
      destroyContact: 'destroy',
      clear: 'clear',
    }),
    editItem(id) {
      this.$router.push({
        name: 'OfficeEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyContact(id).then(() => {
        this.getContacts();
      });
    },
    stampToTime(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth()).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');
      let timePeriod = '';
      let hour = '';
      const minute = String(dateObj.getMinutes()).padStart(2, '0');

      if (dateObj.getHours() < 12) {
        timePeriod = '上午';
        hour = String(dateObj.getHours()).padStart(2, '0');
      }
      if (dateObj.getHours() === 12) {
        timePeriod = '中午';
        hour = String(dateObj.getHours()).padStart(2, '0');
      }
      if (dateObj.getHours() > 12) {
        timePeriod = '下午';
        hour = String(dateObj.getHours() - 12).padStart(2, '0');
      }

      return `${year}.${month}.${date} ${timePeriod} ${hour}:${minute}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-area {
    width: 50px;
    margin-right: 40px;
  }
  .col-location {
    width: 60px;
    margin-right: 40px;
  }
  .highlight-at-oddline:nth-of-type(2n + 1) {
    background-color: $gray-100;
  }
}
</style>
